import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "port" }
const _hoisted_2 = { class: "port-exchange-rate" }
const _hoisted_3 = { class: "port-icon" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_resource_icon = _resolveComponent("resource-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.port.exchangeRate) + ":1", 1),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.resource)
        ? (_openBlock(), _createBlock(_component_resource_icon, {
            key: 0,
            resource: _ctx.resource
          }, null, 8, ["resource"]))
        : _createCommentVNode("", true)
    ])
  ]))
}